/* TUZEX výber veľkosti v21 – zoznam s doručením + dopyt na vypredanú/chýbajúcu veľkosť.
   Sklad (predajňa / externý) číta z aplikácie Multi-Location Inventory (window.inventoryInfo),
   nikdy ho neháda. Veľkosť sa vyberá Shopify rádiami, takže variant sa mení ako doteraz. */
(() => {
  if (customElements.get('tuzex-location-sizes')) return;

  const esc = (text) => String(text ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  class TuzexLocationSizes extends HTMLElement {
    connectedCallback() {
      this.records = new Map();
      this.other = false;
      this.details = this.querySelector('.tx-sizes__dropdown');
      this.root = this.closest('product-info') || document;
      this.inquiry = this.closest('variant-selects')?.querySelector('[data-tx-inquiry]') || this.root.querySelector('[data-tx-inquiry]');

      this.onData = (event) => { this.readCache(); this.readRecords(event.detail?.variantLocations); this.render(); };
      this.onChange = (event) => {
        if (!event.target.matches('.tx-sizes__input')) return;
        this.other = false;
        // stránka nesmie po výbere veľkosti skákať (zatvorenie zoznamu ani prepnutie fotky)
        window.txKeepScroll = Date.now();
        const field = this.querySelector('.tx-sizes__field');
        const before = field ? field.getBoundingClientRect().top : 0;
        if (this.details) this.details.open = false;
        this.render();
        if (field) {
          const after = field.getBoundingClientRect().top;
          if (after < 70) window.scrollBy({ top: after - 110, behavior: 'auto' });
          else if (Math.abs(after - before) > 2) window.scrollBy({ top: after - before, behavior: 'auto' });
        }
      };
      this.onToggle = () => {
        if (!this.details?.open) return;
        // po otvorení ukáž vybranú veľkosť, nie začiatok zoznamu
        const list = this.details.querySelector('.tx-sizes__list');
        const row = this.querySelector('.tx-sizes__input:checked + .tx-size-row');
        if (list && row) {
          requestAnimationFrame(() => {
            const offset = row.offsetTop - list.offsetTop;
            list.scrollTop = Math.max(0, offset - (list.clientHeight - row.offsetHeight) / 2);
          });
        }
      };
      this.onClick = (event) => {
        if (event.target.closest('[data-tx-size-other]')) {
          event.preventDefault();
          this.openOther();
        }
      };
      this.onKey = (event) => {
        if (event.key === 'Escape' && this.details?.open) {
          this.details.open = false;
          this.details.querySelector('summary')?.focus();
        }
      };
      this.onDocClick = (event) => {
        if (this.details?.open && !this.details.contains(event.target)) this.details.open = false;
      };
      this.onOtherRequest = () => this.openOther();

      document.addEventListener('inventoryInfo.appData', this.onData);
      document.addEventListener('inventoryInfo.appRendered', this.onData);
      document.addEventListener('click', this.onDocClick);
      this.addEventListener('change', this.onChange);
      this.details?.addEventListener('toggle', this.onToggle);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.root.addEventListener('tx:size-other', this.onOtherRequest);
      this.guardInquiry();

      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.readCache();
        this.render();
        if (new URLSearchParams(location.search).get('size_inquiry') === '1' && this.inquiry && !this.inquiry.hidden) {
          this.inquiry.scrollIntoView({ block: 'center' });
        }
      });
    }

    disconnectedCallback() {
      document.removeEventListener('inventoryInfo.appData', this.onData);
      document.removeEventListener('inventoryInfo.appRendered', this.onData);
      document.removeEventListener('click', this.onDocClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.root.removeEventListener('tx:size-other', this.onOtherRequest);
    }

    /* Polia dopytu nesmú spustiť zmenu variantu (variant-selects počúva „change“). */
    guardInquiry() {
      if (!this.inquiry || this.inquiry.dataset.txGuarded) return;
      this.inquiry.dataset.txGuarded = 'true';
      ['change', 'input'].forEach((type) => this.inquiry.addEventListener(type, (event) => event.stopPropagation()));
    }

    readCache() {
      const cache = window.inventoryInfo?.[this.dataset.productHandle];
      this.readRecords(cache?.variantLocations || cache?.data?.variantLocations);
    }

    readRecords(records) {
      if (!Array.isArray(records)) return;
      for (const record of records) {
        if (record?.variant && Array.isArray(record.inventoryLocations)) {
          this.records.set(String(record.variant), record.inventoryLocations);
        }
      }
    }

    stateFor(row) {
      if (row.dataset.purchasable !== 'true') return 'sold';
      const locations = this.records.get(row.dataset.variantId);
      if (!locations) return 'available';
      const stockedAt = (id) => locations.some((entry) => String(entry.location?.id) === id && Number(entry.quantity) > 0);
      if (stockedAt(this.dataset.localLocation)) return 'local';
      if (stockedAt(this.dataset.externalLocation)) return 'external';
      return 'available';
    }

    rowText(state) {
      const d = this.dataset;
      if (state === 'local') return `<b>${esc(d.tLocal)}</b><span class="tx-size-row__when"> · ${esc(d.tLocalWhen)}</span>`;
      if (state === 'external') return `<b>${esc(d.tExternal)}</b><span class="tx-size-row__when"> · ${esc(d.tExternalWhen)}</span>`;
      if (state === 'sold') return `<b>${esc(d.tSold)}</b><span class="tx-size-row__when tx-size-row__when--sold"> · ${esc(d.tCanSource)}</span>`;
      return `<b>${esc(d.tAvailable)}</b>`;
    }

    shortText(state) {
      const d = this.dataset;
      if (state === 'local') return d.tLocal;
      if (state === 'external') return d.tExternal;
      if (state === 'sold') return d.tSold;
      return d.tAvailable;
    }

    setDot(dot, state) {
      if (!dot) return;
      dot.classList.toggle('tx-size-dot--local', state === 'local');
      dot.classList.toggle('tx-size-dot--external', state === 'external');
      dot.classList.toggle('tx-size-dot--sold', state === 'sold');
    }

    openOther() {
      this.other = true;
      const checked = this.querySelector('.tx-sizes__input:checked');
      if (checked) checked.checked = false;
      if (this.details) this.details.open = false;
      this.render();
      const field = this.inquiry?.querySelector('[data-tx-inquiry-wanted] input');
      if (field) setTimeout(() => field.focus({ preventScroll: false }), 50);
    }

    render() {
      let selected = null;
      for (const row of this.querySelectorAll('.tx-size-row')) {
        const state = this.stateFor(row);
        row.dataset.locationState = state;
        this.setDot(row.querySelector('.tx-size-dot'), state);
        const where = row.querySelector('[data-tx-row-where]');
        const html = this.rowText(state);
        if (where && where.innerHTML !== html) where.innerHTML = html;
        const input = row.previousElementSibling;
        if (!this.other && input?.checked) selected = { row, state };
      }

      const d = this.dataset;
      const label = this.querySelector('[data-tx-size-label]');
      const info = this.querySelector('[data-tx-field-info]');
      const price = this.querySelector('[data-tx-field-price]');
      const fieldDot = this.querySelector('[data-tx-field-dot]');
      const field = this.querySelector('.tx-sizes__field');
      const setText = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };

      if (this.other) {
        setText(label, d.tOther); setText(info, d.tOtherInfo); setText(price, '');
        if (fieldDot) fieldDot.hidden = true;
      } else if (selected) {
        setText(label, selected.row.dataset.sizeLabel || selected.row.querySelector('[data-tx-row-size]')?.firstChild?.textContent?.trim() || '');
        setText(info, this.shortText(selected.state));
        setText(price, selected.state === 'sold' ? '—' : selected.row.dataset.price || '');
        if (fieldDot) { fieldDot.hidden = selected.state === 'available'; this.setDot(fieldDot, selected.state); }
      } else {
        setText(label, d.tChoose); setText(info, d.tChooseHint); setText(price, '');
        if (fieldDot) fieldDot.hidden = true;
      }
      if (field) {
        field.dataset.state = this.other ? 'other' : selected ? selected.state : 'none';
        price?.classList.toggle('tx-sizes__field-price--sale', !!selected && selected.row.dataset.sale === 'true');
      }

      /* stav pod poľom – len pre dostupnú veľkosť so známym skladom */
      const status = this.querySelector('[data-tx-size-status]');
      if (status) {
        const known = selected && (selected.state === 'local' || selected.state === 'external');
        status.hidden = !known;
        if (known) {
          const local = selected.state === 'local';
          this.setDot(status.querySelector('[data-tx-status-dot]'), selected.state);
          setText(status.querySelector('[data-tx-status-title]'), local ? d.tLocalTitle : d.tExternalTitle);
          setText(status.querySelector('[data-tx-status-text]'), local ? d.tLocalText : d.tExternalText);
          status.dataset.state = selected.state;
        }
      }

      this.renderInquiry(selected);
    }

    renderInquiry(selected) {
      const box = this.inquiry;
      if (!box) return;
      this.guardInquiry();
      const done = box.querySelector('[data-tx-inquiry-done]');
      const soldSelected = !!selected && selected.state === 'sold';
      const show = this.other || soldSelected || (!!done && new URLSearchParams(location.search).get('size_inquiry') === '1');
      box.hidden = !show;
      const product = this.closest('product-info');
      if (product) product.classList.toggle('tx-size-inquiry-open', show);

      if (done) return;
      const sizeLabel = soldSelected ? (selected.row.dataset.sizeLabel || '') : '';
      const title = box.querySelector('[data-tx-inquiry-title]');
      const submit = box.querySelector('[data-tx-inquiry-submit]');
      const wanted = box.querySelector('[data-tx-inquiry-wanted]');
      const wantedInput = wanted?.querySelector('input');
      const sizeInput = box.querySelector('[data-tx-inquiry-size]');
      const skuInput = box.querySelector('[data-tx-inquiry-sku]');
      const linkInput = box.querySelector('[data-tx-inquiry-link]');
      const titleText = this.other ? box.dataset.titleOther : box.dataset.titleSize.replace('[size]', sizeLabel);
      const submitText = this.other ? box.dataset.submitOther : box.dataset.submitSize.replace('[size]', sizeLabel);
      if (title && title.textContent !== titleText) title.textContent = titleText;
      if (submit && submit.textContent.trim() !== submitText) submit.textContent = submitText;
      if (wanted) wanted.hidden = !this.other;
      if (wantedInput) { wantedInput.disabled = !this.other; wantedInput.required = this.other; }
      if (sizeInput) sizeInput.value = sizeLabel;
      if (soldSelected && skuInput && selected.row.dataset.variantSku) skuInput.value = selected.row.dataset.variantSku;
      if (linkInput) {
        if (!linkInput.dataset.base) linkInput.dataset.base = linkInput.value.split('?')[0];
        linkInput.value = soldSelected && selected.row.dataset.variantId ? `${linkInput.dataset.base}?variant=${selected.row.dataset.variantId}` : linkInput.dataset.base;
      }
      const returnTo = box.querySelector('input[name="return_to"]');
      if (returnTo) {
        const url = new URL(returnTo.value || location.pathname, location.origin);
        url.search = '';
        url.searchParams.set('size_inquiry', '1');
        if (soldSelected && selected.row.dataset.variantId) url.searchParams.set('variant', selected.row.dataset.variantId);
        url.hash = box.id;
        returnTo.value = url.pathname + url.search + url.hash;
      }
    }
  }

  customElements.define('tuzex-location-sizes', TuzexLocationSizes);

  /* Odkaz „Tabuľka veľkostí →“ otvorí a ukáže rozbaľovaciu sekciu s tabuľkou. */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-tx-open-details]');
    if (!link) return;
    const target = document.querySelector(link.getAttribute('href'));
    if (target && target.tagName === 'DETAILS') {
      event.preventDefault();
      target.open = true;
      let offset = 16;
      document.querySelectorAll('.tx-site-header, sticky-header, .shopify-section-header-sticky, .section-header').forEach((header) => {
        const style = getComputedStyle(header);
        const rect = header.getBoundingClientRect();
        if ((style.position === 'sticky' || style.position === 'fixed') && rect.bottom > 0 && rect.bottom < 240) offset = Math.max(offset, rect.bottom + 16);
      });
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  });
})();
